import { motion } from 'framer-motion'
import styled, { css } from 'styled-components'

import type { BrandType } from 'services/Branding/types'

import type { IDropdownCourseContent } from '../DropdownCourse'

interface IContentRootStyledParams {
  $disbale?: boolean
  $type: IDropdownCourseContent['type']
  $styleType?: IDropdownCourseContent['styleType']
  $theme: BrandType['theme']
}

const disabled = (disbale?: boolean) =>
  disbale &&
  css`
    cursor: not-allowed;
  `

const tooltip = css`
  padding: 4px 8px;
  background-color: var(--color-background-dark);
  color: var(--color-white);
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  line-height: 18px;
  /* word-break: break-word; */
`

const themeStyles = (theme: BrandType['theme']) => css`
  background-color: ${theme.primaryBackgroundColor};
  color: ${theme.primaryTextColor};
`

const clearStyleType = css`
  padding: 0;
`

const ContentStyled = styled(motion.div)<IContentRootStyledParams>`
  display: flex;
  position: absolute;
  z-index: 10000;
  pointer-events: all;
  padding: 8px 0;
  border-radius: 6px;
  box-shadow: var(--box-shadow-default);
  background: var(--color-background-main);
  color: var(--color-text-main);
  overflow: visible;
  overflow-y: auto;
  flex-direction: column;
  ${({ $type }) => $type === 'tooltip' && tooltip};
  ${({ $disbale }) => disabled($disbale)};
  ${({ $styleType }) => $styleType === 'clear' && clearStyleType};
  ${({ $theme }) => themeStyles($theme)};
`

export default ContentStyled
